<template>
  <svg
    viewBox="0 0 48 32"
    xmlns="http://www.w3.org/2000/svg"
    class="icon-svg icon-fedex"
  >
    <g fill-rule="evenodd">
      <g transform="translate(-1076.000000, -745.000000)">
        <g transform="translate(1076.000000, 745.000000)">
          <rect
            stroke="#d5d5d5"
            fill="#ffffff"
            x="0.5"
            y="0.5"
            width="47"
            height="31"
            rx="4"
          />
          <g transform="translate(7.000000, 10.000000)">
            <path
              d="M29.975,3.8865 L31.464,5.527 L32.8975,3.8865 L35.9585,3.8865 L32.967,7.2505 L35.9995,10.6415 L32.815,10.6415 L31.34,8.9875 L29.8785,10.6415 L26.8035,10.6415 L29.8095,7.2645 L26.8035,3.8865 L29.975,3.8865 Z M26.8035,0 L26.8035,2.372 L23.399,2.372 L23.399,3.8865 L26.8035,3.8865 L26.8035,6.1685 L23.399,6.1685 L23.399,8.2635 L26.8035,8.2635 L26.8035,10.6415 L20.897,10.6415 L20.897,0 L26.8035,0 Z"
              fill="#FF6600"
            />
            <path
              d="M16.893,9.0215 C15.9745,9.0215 15.404,8.1655 15.404,7.272 C15.404,6.317 15.9005,5.3985 16.893,5.3985 C17.9225,5.3985 18.3325,6.317 18.3325,7.272 C18.3325,8.178 17.898,9.0215 16.893,9.0215 Z M8.0395,6.2005 C8.1965,5.5245 8.7205,5.0825 9.375,5.0825 C10.0955,5.0825 10.5935,5.511 10.724,6.2005 C10.7795,6.2005 8.0395,6.2005 8.0395,6.2005 Z M18.405,0 L18.405,4.355 L18.378,4.355 C17.826,3.721 17.137,3.5005 16.3375,3.5005 C14.699,3.5005 13.4655,4.6145 13.032,6.0865 C12.538,4.4645 11.264,3.4705 9.375,3.4705 C7.841,3.4705 6.63,4.159 5.9975,5.281 L5.9975,3.8865 L2.8265,3.8865 L2.8265,2.372 L6.287,2.372 L6.287,0 L0,0 L0,10.6415 L2.8265,10.6415 L2.8265,6.1685 L5.644,6.1685 C5.56,6.497 5.515,6.849 5.515,7.2205 C5.515,9.44 7.211,10.9975 9.375,10.9975 C11.195,10.9975 12.3945,10.143 13.029,8.5855 L10.6065,8.5855 C10.279,9.054 10.03,9.1925 9.375,9.1925 C8.6155,9.1925 7.9605,8.53 7.9605,7.744 L12.893,7.744 C13.107,9.5075 14.4805,11.028 16.365,11.028 C17.178,11.028 17.923,10.628 18.378,9.9525 L18.405,9.9525 L18.405,10.6415 L20.897,10.6415 L20.897,0 L18.405,0 L18.405,0 Z"
              fill="#4D148C"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
